"use strict";
import { InterfaceEventName } from "@uniswap/analytics-events";
import { sendAnalyticsEvent } from "uniswap/src/features/telemetry/send";
export function outboundLink({ label }) {
  sendAnalyticsEvent(InterfaceEventName.EXTERNAL_LINK_CLICK, {
    label
  });
}
